import styled from 'styled-components';

export const Wrapper = styled.div`
    height: 100%;
    background-color: rgb(244, 244, 244);

    .udesk-qa-ui-spin-nested-loading {
        height: 100%;

        .udesk-qa-ui-spin-container {
            height: 100%;
        }
    }
`;

export const Content = styled.div`
    height: ${(props) => (props.hasAudio ? 'calc(100% - 60px)' : '100%')};
    padding: 8px 8px 0px;
`;

export const Footer = styled.div`
    height: ${(props) => (props.hasAudio ? '60px' : '0')};
    background: #fff;
`;
